<template>
  <div class="d-flex justify-content-end">
    <EmployeeGroupSchedulePurgeButton
      @button-clicked="deleteSchedule"
    ></EmployeeGroupSchedulePurgeButton>
  </div>
</template>

<script>
import EmployeeGroupSchedulePurgeButton from "@/modules/company/components/group/schedule/EmployeeGroupSchedulePurgeButton";

export default {
  name: "EmployeeGroupScheduleControl",
  components: { EmployeeGroupSchedulePurgeButton },
  methods: {
    /**
     * When child emitted on click, calls store to delete group schedule.
     */
    deleteSchedule() {
      const groupId = this.$store.getters.getSelectedEmployeeGroup.id;
      console.log(groupId);

      this.$bvModal
        .msgBoxConfirm(this.$t("GROUP.SCHEDULE.DELETECONFIRM"))
        .then((isOk) => {
          console.log(isOk);

          if (isOk) this.attempt(groupId);
          else
            this.$bvToast.toast(this.$t("GROUP.SCHEDULE.DELETE_CANCELLED"), {
              variant: "primary",
            });
        });
    },

    attempt(groupId) {
      this.$store
        .dispatch("deleteGroupSchedule", {
          id: groupId,
        })
        .then(() => {
          this.$bvModal.msgBoxOk("Schedule is deleted.");
          this.$store.dispatch("clearEmployeeGroupScheduleList");
        })
        .catch(() => this.$bvModal.msgBoxOk("Cannot delete Schedule."));
    },
  },
};
</script>

<style scoped></style>
